import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import * as actionCreators from "./actions.js";

const EcoSettingService = () => {
    const dispatch = useDispatch();
    const { getEcoSettings } = actionCreators;

    useEffect(() => {
        dispatch(getEcoSettings());
    }, []);

    return <Fragment />;
};

export default EcoSettingService;
